import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { rethrowAsSapError, SapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EquipmentAdapter } from 'src/app/models/domain/adapters/equipment-adapter';
import { EquipmentDetails } from 'src/app/models/domain/equipment-details';
import { IEquipmentDetails } from 'src/app/state/equipment/equipment.model';
import { EquipmentService } from 'src/generated-clients/construction_cds';

@Injectable({
  providedIn: 'root',
})
export class EquipmentItemDataService {
  public constructor(
    private readonly equipmentApi: EquipmentService,
    private readonly equipmentAdapter: EquipmentAdapter,
    private readonly httpClient: HttpClient
  ) {}

  public getEquipmentsByDesignId(designId: string): Observable<EquipmentDetails[]> {
    return this.equipmentApi
      .yPMEQUIPMENTVGet(undefined, undefined, `designId eq '${designId}'`, undefined, [
        'equipmentNumber',
      ])
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d.results || res.d.results.length === 0) {
            throw new SapError('Sap Error');
          }

          return res.d.results.map((equipments) => this.equipmentAdapter.adaptToDomain(equipments));
        })
      );
  }

  public getEquipmentsByEquipmentId(equipmentId: string): Observable<EquipmentDetails | undefined> {
    return this.equipmentApi
      .yPMEQUIPMENTVGet(undefined, undefined, `equipmentNumber eq '${equipmentId}'`, undefined, [])
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d.results || res.d.results.length === 0) {
            return undefined;
          }

          return this.equipmentAdapter.adaptToDomain(res.d.results[0]);
        })
      );
  }

  public getEquipments(designId: string): Observable<EquipmentDetails[]> {
    return this.httpClient.get<IEquipmentDetails[]>(`api/equipment/${designId}`).pipe(
      rethrowAsSapError(),
      map((res) => {
        return res.map((eq) => this.equipmentAdapter.adaptToDomain(eq));
      })
    );
  }
}
